import { io } from "socket.io-client";

// export const url = "https://jivinibackend.firstfloor.site/api";
// export const socket = io("https://jivinibackend.firstfloor.site");

export const url = "https://api.jivini.in/api";
export const socket = io("https://api.jivini.in/api");

// export const url = "https://api-test.jivini.in/api";
// export const socket = io("https://api-test.jivini.in");

// export const url = "http://localhost:3033/api";
